<nz-card class="header-card" nzSize="small">
  <app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
  <div class="flex justify-between my-3">
    <h2 class="!text-lg xxsm:!text-2xl my-0">Acts</h2>
  </div>
</nz-card>

<nz-card class="!my-4">
  <div class="flex flex-col sm:flex-row gap-3 sm:gap-4 items-start sm:items-center justify-between">
    <div class="flex flex-col sm:flex-row gap-3 sm:gap-4 items-start sm:items-center w-full sm:w-auto">
      <p class="text-[#441752] font-semibold whitespace-nowrap text-sm sm:text-base">Filter by Year:</p>
      <nz-select
        class="w-full sm:w-[200px]"
        nzSize="large"
        [(ngModel)]="selectedYear"
        (ngModelChange)="filterByYear()"
        nzPlaceHolder="All Years">
        <nz-option *ngFor="let year of years" [nzValue]="year" [nzLabel]="year.toString()"></nz-option>
      </nz-select>
      <button
        *ngIf="selectedYear"
        class="px-3 sm:px-4 py-2 outline-none border border-solid border-[#441752] text-[#441752] bg-transparent rounded-md whitespace-nowrap text-sm sm:text-base w-full sm:w-auto"
        (click)="clearFilter()">
        Clear Filter
      </button>
    </div>
  </div>
</nz-card>

<nz-empty class="mt-10" *ngIf="data.length === 0"></nz-empty>

<nz-card class="!my-4" *ngIf="data.length > 0">
  <div class="overflow-x-auto" style="scrollbar-width: thin;">
    <nz-table
      [nzData]="data"
      [nzFrontPagination]="false"
      [nzShowPagination]="false"
      nzSize="middle"
      [nzScroll]="{ x: '600px' }">
      <thead>
        <tr>
          <th nzWidth="120px">Act No</th>
          <th nzWidth="200px">Title</th>
          <th nzWidth="80px" class="hidden sm:table-cell">Year</th>
          <th nzWidth="200px" class="text-center">Downloads</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let act of data">
          <td class="font-medium text-[#441752]">{{ act.actNo }}</td>
          <td>{{ act.title }}</td>
          <td class="hidden sm:table-cell">{{ act.year }}</td>
          <td class="text-center">
            <div class="flex flex-row justify-center items-center gap-2 flex-wrap">
              <a
                *ngIf="getFileUrl(act.englishFile) !== '#'"
                [href]="getFileUrl(act.englishFile)"
                target="_blank"
                nz-button
                nzSize="small"
                nzType="primary">
                English
              </a>
              <a
                *ngIf="getFileUrl(act.sinhalaFile) !== '#'"
                [href]="getFileUrl(act.sinhalaFile)"
                target="_blank"
                nz-button
                nzSize="small"
                nzType="primary">
                Sinhala
              </a>
              <a
                *ngIf="getFileUrl(act.tamilFile) !== '#'"
                [href]="getFileUrl(act.tamilFile)"
                target="_blank"
                nz-button
                nzSize="small"
                nzType="primary">
                Tamil
              </a>
              <span
                *ngIf="getFileUrl(act.englishFile) === '#' && getFileUrl(act.sinhalaFile) === '#' && getFileUrl(act.tamilFile) === '#'"
                class="text-gray-400 text-sm">
                No files available
              </span>
            </div>
            <div class="sm:hidden text-xs text-gray-500 mt-1 text-center">Year: {{ act.year }}</div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</nz-card>

<div class="mt-4 flex justify-center sm:justify-end" *ngIf="data.length > 0">
  <nz-pagination
    class="mt-4 sm:mt-8"
    (nzPageIndexChange)="onCurrentPageDataChange($event)"
    [nzPageIndex]="currentPage"
    [nzTotal]="totalDocs"
    [nzPageSize]="pageSize"
    [nzSimple]="false"
    [nzShowSizeChanger]="false"
    nzSize="small"></nz-pagination>
</div>




